import request from 'utils/request';

const PREFIX = '/api/aff-receipt-entity-report/';

export const AffBillingEntityAPI = {
  LIST: PREFIX + 'list',
};

export function getAffPaymentEntityReport(data) {
  return request({
    url: AffBillingEntityAPI.LIST,
    method: 'post',
    data,
  });
}
